module.exports = __webpack_public_path__ + "images/emoji/tea.ba01fce69d92c07af940.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tea.png
// module id = nrWn
// module chunks = 14